import { DayHeaderInfo } from '@fullcalendar/react'
import { isAppToday } from './timezone'

export function dayHeaderClass(e: DayHeaderInfo) {
  return isAppToday(e.date)
    ? 'calendar-day-header FullCalendarHeaderCurrentDay'
    : 'calendar-day-header'
}
